import React from "react";
import { Link } from "react-router-dom";
import "../../styles/admin-common.css";

const policies = [
  {
    title: "SpotDeal details (GST & company)",
    body: "Update legal name, address, GSTIN, GST %, state and support contacts used on vendor commission invoices and wallet receipts.",
    link: "/settings/spotdeal",
    linkLabel: "Edit SpotDeal details",
  },
  {
    title: "Vendor agreement",
    body: "Immutable versioned SpotDeal vendor partnership agreement. Each publish creates a new audit-trail version (change summary + admin). Placeholders like {{vendorName}} fill into the PDF. On approve the same PDF is updated with the company authorized signatory — no duplicate file. Fees are changeable with email/app notice as stated in the terms.",
    link: "/policies/vendor-agreement",
    linkLabel: "Edit vendor agreement & version history",
  },
  {
    title: "Commission & wallet",
    body: "Vendors top up before accepting orders. On assignment we hold platform commission (region %) plus a convenience fee that is a % of the commission amount only — not of the device price (e.g. ₹100 commission + 1% fee → ₹101 held). Both lines appear in transaction details. Holds release on cancel, reject, timeout, or reassignment. Configure rates under Regions.",
    link: "/regions",
    linkLabel: "Manage regions, commission & convenience fee",
  },
  {
    title: "Assessment templates",
    body: "Define default questions and defects per product category. Device models inherit templates; per-model overrides win by question group or defect title.",
    link: "/devices",
    linkLabel: "Categories & templates",
  },
  {
    title: "Order lifecycle",
    body: "Pending → assigned → inspection → customer approval → payout. Admins can assign vendors, cancel with reason, and view full assessment snapshots on each order.",
    link: "/orders",
    linkLabel: "Order management",
  },
  {
    title: "Cancellations",
    body: "Customers may cancel before pickup. Admin cancellations require a reason. Wallet holds are always released when an order does not complete.",
    link: "/orders",
    linkLabel: "View orders",
  },
  {
    title: "Data access",
    body: "Customer contact and address data is shared only with the assigned vendor. Admin access requires authenticated staff accounts.",
    link: "/users",
    linkLabel: "User management",
  },
];

const Policies = () => (
  <div className="admin-page">
    <h2>Platform policies</h2>
    <p className="subtitle">
      Operational reference for SpotDeal. Policy behavior is enforced in the backend; use the links below to manage related settings.
    </p>
    <div className="quick-links" style={{ marginBottom: 24 }}>
      <Link to="/settings/spotdeal" className="quick-link-card"><strong>SpotDeal details</strong><span>GST, GSTIN, company address</span></Link>
      <Link to="/policies/vendor-agreement" className="quick-link-card"><strong>Vendor agreement</strong><span>Terms, company address, publish</span></Link>
      <Link to="/regions" className="quick-link-card"><strong>Regions</strong><span>Commission, convenience fee & pincodes</span></Link>
      <Link to="/questions?scope=category" className="quick-link-card"><strong>Questions</strong><span>Category templates</span></Link>
      <Link to="/defects?scope=category" className="quick-link-card"><strong>Defects</strong><span>Category templates</span></Link>
      <Link to="/models" className="quick-link-card"><strong>Models</strong><span>Catalog & overrides</span></Link>
    </div>
    {policies.map((policy) => (
      <div key={policy.title} className="admin-card">
        <h3>{policy.title}</h3>
        <p style={{ margin: "0 0 12px", lineHeight: 1.6, color: "#475569" }}>{policy.body}</p>
        <Link to={policy.link}>{policy.linkLabel} →</Link>
      </div>
    ))}
  </div>
);

export default Policies;
